import React, { FC } from 'react';
import { l10n } from '../with-app-root/i18n/i18nUtil';
import './Clock.css';

interface Props {
  size?: number;
}

const Clock: FC<Props> = props => {
  const { size = 24 } = props;
  return (
    <svg width={size} height={size} style={{ display: 'block' }}>
      <title>{l10n('components.clock.clock')}</title>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - 1}
        fill="transparent"
        stroke="#565656"
      />
      <path
        className="hour-hand"
        d={`M${size / 2},${size / 2}h${(size / 2) * 0.75}`}
        fill="none"
        stroke="#565656"
        strokeWidth={Math.max(1.5, size / 30)}
      />
      <path
        className="minute-hand"
        d={`M${size / 2},${size / 2}h${(size / 2) * 0.75}`}
        fill="none"
        stroke="#565656"
        strokeWidth={Math.max(1, size / 30)}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={Math.max(2, size / 30)}
        fill="#565656"
      />
    </svg>
  );
};

export default Clock;
